import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Timer } from 'lucide-react';
export function CountdownTimer() {
  // Start with 23:59:51 as requested
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 51
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev; // Stop at 0
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-8 md:py-12 bg-red-50 border-y border-red-100" data-id="element-65">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-67">
          <div className="flex items-center gap-2 text-red-600 font-bold tracking-wider uppercase mb-4 md:mb-6 text-xs md:text-base" data-id="element-68">
            <Timer className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-69" />
            EL PRECIO DE LANZAMIENTO TERMINA EN:
          </div>

          <div className="flex items-center justify-center gap-2 md:gap-4 mb-4 md:mb-6" data-id="element-70">
            <div className="bg-white border-2 border-red-200 rounded-lg md:rounded-xl w-16 h-18 md:w-20 md:h-24 flex flex-col items-center justify-center shadow-sm py-2 md:py-0" data-id="element-71">
              <span className="text-2xl md:text-4xl font-bold text-gray-900 font-serif" data-id="element-72">
                {formatNumber(timeLeft.hours)}
              </span>
              <span className="text-[10px] md:text-xs text-gray-500 uppercase font-medium mt-0.5 md:mt-1" data-id="element-73">
                Horas
              </span>
            </div>
            <span className="text-2xl md:text-3xl font-bold text-red-300 pb-4 md:pb-6" data-id="element-74">
              :
            </span>
            <div className="bg-white border-2 border-red-200 rounded-lg md:rounded-xl w-16 h-18 md:w-20 md:h-24 flex flex-col items-center justify-center shadow-sm py-2 md:py-0" data-id="element-75">
              <span className="text-2xl md:text-4xl font-bold text-gray-900 font-serif" data-id="element-76">
                {formatNumber(timeLeft.minutes)}
              </span>
              <span className="text-[10px] md:text-xs text-gray-500 uppercase font-medium mt-0.5 md:mt-1" data-id="element-77">
                Min
              </span>
            </div>
            <span className="text-2xl md:text-3xl font-bold text-red-300 pb-4 md:pb-6" data-id="element-78">
              :
            </span>
            <div className="bg-white border-2 border-red-200 rounded-lg md:rounded-xl w-16 h-18 md:w-20 md:h-24 flex flex-col items-center justify-center shadow-sm py-2 md:py-0" data-id="element-79">
              <span className="text-2xl md:text-4xl font-bold text-red-600 font-serif" data-id="element-80">
                {formatNumber(timeLeft.seconds)}
              </span>
              <span className="text-[10px] md:text-xs text-gray-500 uppercase font-medium mt-0.5 md:mt-1" data-id="element-81">
                Seg
              </span>
            </div>
          </div>

          <p className="text-sm md:text-base text-gray-700 font-medium mb-5 md:mb-8" data-id="element-82">
            Después sube $8.000 ARS y no vuelve a bajar.
          </p>

          <div className="w-full max-w-md mx-auto" data-id="element-83">
            <div className="flex justify-between text-sm font-bold text-gray-700 mb-2" data-id="element-84">
              <span data-id="element-85">Cupos al precio de lanzamiento</span>
              <span className="text-red-600" data-id="element-86">68% tomados</span>
            </div>
            <div className="h-3 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-87">
              <motion.div className="h-full bg-gradient-to-r from-red-500 to-red-600" initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.5
            }} data-id="element-88" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}